export default (loadingOrNot) => ({
  type: 'TOGGLE_LOADING',
  payload: loadingOrNot,
});
